import { render } from "./QuestionBankEdit.vue?vue&type=template&id=29b2b226&scoped=true"
import script from "./QuestionBankEdit.vue?vue&type=script&lang=js"
export * from "./QuestionBankEdit.vue?vue&type=script&lang=js"

import "./QuestionBankEdit.vue?vue&type=style&index=0&id=29b2b226&lang=less&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b2b226"]])

export default __exports__